/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { valorAPesos } from "utils/formatters";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox display="flex" flexDirection="row">
            {item?.cuentaCorriente && (
              <Tooltip title="Cuenta corriente" placement="top">
                <Icon fontSize="small" color="primary">
                  account_balance_wallet
                </Icon>
              </Tooltip>
            )}
            {item?.cuentaCorriente && item?.pagado && (
              <Tooltip title="Cta. Cte. Pagada" placement="top">
                <Icon fontSize="small" color="uproGreen">
                  attach_money
                </Icon>
              </Tooltip>
            )}
          </SoftBox>
        ),
        id: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        createdAt: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.createdAt ? dayjs(item?.createdAt).format("DD-MM-YYYY") : ""}
            </SoftTypography>
          </SoftBox>
        ),
        total: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.total ? valorAPesos(item?.total) : ""}
            </SoftTypography>
          </SoftBox>
        ),
        // accion: (
        //   <SoftBox mr={2}>
        //     <Tooltip title="Opciones" placement="top">
        //       <Icon
        //         sx={{ color: "primary", cursor: "pointer", mx: 0.5 }}
        //         fontSize="small"
        //         onClick={(e) => handleOpenMenu(e, item)}
        //       >
        //         more_vert
        //       </Icon>
        //     </Tooltip>
        //   </SoftBox>
        // ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "N°", align: "left" },
  { name: "createdAt", desc: "Fecha realizado", align: "left" },
  { name: "total", desc: "Total", align: "right", noOrder: true },
  // { name: "accion", desc: "Acciones", align: "right", noOrder: true },
];

export default { columns, getRows };
